export default "__VITE_ASSET__15feb7c2__"